export const formatAgeSec = (sec)=>{
    if (sec < 60) return `${sec}s`;
    if (sec < 3600) return `${Math.floor(sec / 60)}m`;
    if (sec < 86400) {
        const h = Math.floor(sec / 3600);
        const m = Math.floor(sec % 3600 / 60);
        return m > 0 ? `${h}h ${m}m` : `${h}h`;
    }
    const d = Math.floor(sec / 86400);
    const h = Math.floor(sec % 86400 / 3600);
    return h > 0 ? `${d}d ${h}h` : `${d}d`;
};

//# sourceMappingURL=formatAgeSec.js.map